<template>
    <div class="x_body">
        <b-row class="card-pos" style="height: 10vh; margin-bottom: 15px;">
            <b-col sm="2" class="align-center">
                <h1 id="pos-text">{{$t('pos')}}</h1>
            </b-col>
            <b-col sm="10">
                <div class="align-center" style="padding-right: 20px;">
                    <b-form-input v-model="query.Text"
                                  @keypress.enter="toList"
                                  type="text"
                                  size="lg"
                                  :placeholder="$t('search')"
                                  autocomplete="off"
                                  style="border-radius: 8px;" />
                </div>
            </b-col>
        </b-row>
        <b-row style="height: 85vh; margin: 0px 15px;">
            <b-col sm="8">
                <b-row>
                    <b-col sm="12">
                        <div style="padding-right: 15px; float: left; width: 100px;">
                            <b-button variant="outline-primary" style="width: 100%;" @click="changeCategory('')">{{$t('all')}}</b-button>
                        </div>
                        <div style="float: right; max-width: calc(98% - 130px); width: 100%; margin-right: 30px;">
                            <template v-if="categories.length">
                                <VueSlickCarousel v-bind="settings">
                                    <template v-for="(ret, index) in categories">
                                        <b-button variant="outline-primary" :key="index" @click="changeCategory(ret.Id)">{{ret.Name}}</b-button>
                                    </template>
                                </VueSlickCarousel>
                            </template>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" style="padding-top: 15px;">
                        <template v-for="(ret, index) in products">
                            <b-card :key="index"
                                    :img-src="productImage(ret.Image)"
                                    :img-alt="ret.Name"
                                    img-top
                                    tag="article"
                                    class="mb-2 card-custom"
                                    @click="$emit('addItem', ret, true)">
                                <b-card-text style="text-align: center;" :id="ret.Id" class="text-truncate">{{ret.Name}}</b-card-text>
                                <b-card-text style="text-align: center; color: #ff0000;">{{$dollar(ret.Price)}}</b-card-text>
                                <b-popover :target="ret.Id" triggers="hover" placement="top">
                                    <template #title>
                                        {{ret.Name}}
                                    </template>
                                </b-popover>
                            </b-card>
                        </template>
                    </b-col>
                </b-row>
            </b-col>
            <b-col sm="4" class="card-pos">
                <b-row>
                    <b-col sm="12" style="padding-top: 15px;">
                        <b-list-group>
                            <b-list-group-item class="d-flex align-items-center" @click="showModalCustomer">
                                <b-avatar class="mr-3 b-avatar-custom"></b-avatar>
                                <span class="mr-auto">{{summary.CustomerName}}</span>
                                <i class="fa fa-plus-circle" aria-hidden="true"></i>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                    <b-col sm="12" style="padding-top: 15px; height: calc(100% - 230px); top: 60px; position: absolute;">
                        <div class="hide-scroll-bar" style="overflow-y: scroll;">
                            <b-list-group>
                                <template v-for="(ret, index) in orderItems">
                                    <b-list-group-item class="d-flex align-items-center b-list-group-item-custom" :key="index">
                                        <b-avatar class="mr-3 b-avatar-custom"></b-avatar>
                                        <div class="mr-auto">
                                            <span style="margin-left: 0.25rem;">{{ret.Name}}</span>
                                            <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                                                <b-button-group class="mx-1" size="sm">
                                                    <b-button @click="$emit('addItem', ret, false)">-</b-button>
                                                </b-button-group>
                                                <b-button-group class="mx-1" size="sm">
                                                    <b-button>{{ret.Quantity}}</b-button>
                                                </b-button-group>
                                                <b-button-group class="mx-1" size="sm">
                                                    <b-button @click="$emit('addItem', ret, true)">+</b-button>
                                                </b-button-group>
                                            </b-button-toolbar>
                                        </div>
                                        <span style="color: #ff0000;">{{$dollar(ret.SubTotal)}}</span>
                                    </b-list-group-item>
                                </template>
                            </b-list-group>
                        </div>
                    </b-col>
                    <b-col sm="12" style="padding-top: 15px; position: absolute; bottom: 15px;">
                        <div>
                            <span>{{$t('sub_total')}} (3 {{$t('items')}})</span>
                            <span style="color: #ff0000; float: right;">{{$dollar(summary.SubTotal)}}</span>
                        </div>
                        <div>
                            <span>{{$t('tax_includes')}}</span>
                            <span style="color: #ff0000; float: right;">{{$dollar(summary.Tax)}}</span>
                        </div>
                        <div>
                            <span>{{$t('discount')}}</span>
                            <span style="color: #ff0000; float: right;">{{$dollar(summary.Discount)}}</span>
                        </div>
                        <div style="margin-top: 15px;">
                            <b-button variant="primary" style="border-radius: 8px; width: 100%; height: 50px;" @click="showTender">
                                <span style="float: left;">{{$t('charge')}}</span>
                                <span style="float: right;">{{$dollar(summary.GrandTotal)}}</span>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <CustomerSelectModal ref="selectCustomer" @select="selectCustomer"></CustomerSelectModal>
    </div>
</template>

<script>
    import VueSlickCarousel from 'vue-slick-carousel';
    import CustomerSelectModal from '../../Customer/Components/SelectModal.vue';
    export default {
        components: {
            VueSlickCarousel,
            CustomerSelectModal
        },
        props: {
            summaryProp: Object,
            orderItemsProp: Array
        },
        data: function () {
            return {
                query: {
                    Text: '',
                    CategoryId: '',
                    CanSold: 1,
                    SortField: 'Name',
                    SortType: 'ASC',
                    Skip: 0,
                    Limit: 1000,
                    CompanyId: this.$store.state.company.Id
                },
                categories: [],
                products: [],
                orderItems: this.orderItemsProp,
                summary: this.summaryProp,
                settings: {
                    dots: false,
                    focusOnSelect: false,
                    infinite: true,
                    swipeToSlide: true,
                    speed: 800,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        },
        created() {
            this.init();
            this.toList();
        },
        methods: {
            init() {
                var loading = this.$loading.show();
                this.$api().post('category/list', { CompanyId: this.$store.state.company.Id }).then(res => {
                    if (this.$isValid(res)) {
                        this.categories = res.data.Json.Categories;
                        const count = this.categories.length;
                        if (count < 5) {
                            this.$set(this.settings, 'slidesToShow', count);
                            this.$set(this.settings, 'slidesToScroll', (count - 1));
                        } else {
                            this.$set(this.settings, 'slidesToShow', 5);
                            this.$set(this.settings, 'slidesToScroll', 3);
                        }
                    }
                }).finally(function () { loading.hide(); });
            },
            toList() {
                var loading = this.$loading.show();
                this.$api().post('item/list', this.query).then(res => {
                    if (this.$isValid(res)) {
                        this.products = res.data.Data;
                    }
                }).finally(function () { loading.hide(); });
            },
            changeCategory(id) {
                this.query.CategoryId = id;
                this.toList();
            },
            showTender() {
                const data = {
                    isShowTender: true,
                    summary: this.summary,
                    orderItems: this.orderItems
                };
                this.$emit("showTender", data);
            },
            productImage(img) {
                if (this.$isEmpty(img)) {
                    return "/img/no-image.svg";
                }
                return this.$base() + 'image/items/' + img;
            },
            showModalCustomer() {
                this.$refs.selectCustomer.$refs.innermodal.show();
            },
            selectCustomer(ret) {
                this.$set(this.summary, 'CustomerId', ret.Id);
                this.$set(this.summary, 'CustomerName', ret.Name);
                this.$refs.selectCustomer.$refs.innermodal.hide();
            }
        }
    };
</script>
